<div class="aplly-cont not-activated" *ngIf="showApplyOFLCont">
  <div class="apply-job-title">
    {{ 'global.open_application' | translate }}
  </div>
  <div class="apply-skills">
    {{ 'global.open_application_info' | translate }}
  </div>

  <button type="text" class="btn w-lg h-lg secondary" [disabled]="true">
    {{ 'global.apply' | translate }}
  </button>

  <div class="save-profile-info">{{ 'global.save_profile_to_apply' | translate }}</div>
</div>

<div class="aplly-cont" *ngIf="showApplyCont" [class.not-activated]="!isActivated">
  <div class="apply-job-title">
    {{ vacancyDetails?.job_title }}
  </div>
  <div class="apply-skills">
    <div class="skill-item" *ngIf="vacancyDetails?.work_experience_level">
      {{ 'global.' + workLevels[vacancyDetails.work_experience_level] | translate }}
    </div>
    <div class="skill-item" *ngIf="vacancyDetails?.language_skills">
      <div class="education-item" *ngFor="let item of vacancyDetails.language_skills; let i = index">
        {{ item.skill_name }}{{ i !== vacancyDetails.language_skills.length - 1 ? ',' : '' }}
      </div>
    </div>
    <div class="skill-item" *ngIf="vacancyDetails?.education_levels">
      <div class="education-item" *ngFor="let item of vacancyDetails.education_levels; let i = index">
        {{ item.name }}{{ i !== vacancyDetails.education_levels.length - 1 ? ',' : '' }}
      </div>
    </div>
  </div>

  <button
    *ngIf="!alreadyApplied"
    type="text"
    class="btn w-lg h-lg secondary"
    [disabled]="!isActivated"
    (click)="onApply()"
  >
    {{ 'global.apply' | translate }}
  </button>
  <button *ngIf="alreadyApplied" type="text" class="btn w-lg h-lg secondary already-applied" [disabled]="true">
    {{ 'global.already_applied' | translate }}
  </button>
  <div class="save-profile-info" *ngIf="!isActivated">{{ 'global.save_profile_to_apply' | translate }}</div>
</div>
